const translations = {
    addMalfunction: 'Add Malfunction'
};

export default translations;
